import { QueryKey, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError, AxiosProgressEvent } from 'axios';
import { useNavigate } from 'react-router-dom';

import { axiosInstance as authAxios } from '../config/axios';
import { uploadAxiosInstance } from '../config/uploadAxios'; // Import the upload instance
import { isValid } from '../utils/queryKeys';

type HTTPMutateMethod = 'get' | 'post' | 'put' | 'delete' | 'patch'; // Added 'patch'

export type SimpleMutationProps<ReqDataType> = {
	method: HTTPMutateMethod;
	url: string | ((data?: ReqDataType) => string);
	dependencies?: unknown[];
	queriesToInvalidate?: QueryKey[];
	navigateUrl?: string;
	callback?: () => void;
	onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
	useAuth?: boolean;
};

const useSimpleMutation = <ReqDataType, ResDataType = unknown>({
	method,
	url,
	dependencies,
	queriesToInvalidate,
	navigateUrl,
	callback,
	onUploadProgress,
}: SimpleMutationProps<ReqDataType>) => {
	const navigate = useNavigate();
	const queryClient = useQueryClient();

	const mutation = useMutation<ResDataType, AxiosError, ReqDataType>({
		mutationFn: async (data?: ReqDataType) => {
			if (dependencies && !dependencies.every((dep) => !!dep)) {
				return Promise.reject(new Error('Missing dependencies'));
			}

			// Determine which axios instance to use
			const axiosClient = onUploadProgress
				? uploadAxiosInstance
				: authAxios;

						const response = await axiosClient[method]<ResDataType>(

							typeof url === 'function' ? url(data) : url,

							data,

							{ onUploadProgress }

						);

			

						return response.data;

					},
		onSuccess: () => {
			if (queriesToInvalidate) {
				queriesToInvalidate.forEach((query) => {
					if (isValid(query)) {
						queryClient.invalidateQueries({ queryKey: query });
					}
				});
			}

			if (navigateUrl) {
				navigate(navigateUrl);
			}

			if (callback) {
				callback();
			}
		},
	});

	return mutation;
};

export default useSimpleMutation;
